import styled from 'styled-components';

import { WithHidden } from '~/core/styleTypes';

export const GAME_STORY_HEIGHT = 87;

export const GameStoriesContainer = styled.div<WithHidden>`
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'block')};
    // Basically this is to account for a potential scrollbar. When there is no scroll bar, the min-height will be used.
    // If there is more content than can fit on the row then a scrollbar will appear which will force the element to get
    // bigger. The max-height accounts for this added height.
    min-height: ${GAME_STORY_HEIGHT}px;
    max-height: 98px;
    overflow-x: auto;
`;

export const LoadingDisplayContainer = styled.div<WithHidden>`
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'block')};

    .inline-loader {
        background: initial;
        padding: 0;
    }
`;
